<template>
    <vx-table-row>
        <vx-table-row-title class="xl:col-span-2!">
            {{ formatPhoneNumber(props.modelValue.phone_number) }}
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Number Type: </template>
            {{ formatNumberType(props.modelValue.number_type) }}
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Country: </template>
            {{ countryEmoji(props.modelValue.iso_country) }} {{ props.modelValue.iso_country }}
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-dropdown placement="right">
                <vx-button
                    data-test="dropdown"
                    aria-label="Phone number actions"
                    type="button"
                    color="muted"
                    outline
                    class="w-[45px]"
                >
                    <font-awesome-icon widthAuto :icon="faEllipsis" />
                </vx-button>

                <template v-slot:items>
                    <vx-dropdown-item
                        data-test="assign-to-group"
                        :href="`/settings/teams/${props.modelValue.team_id}/phone-numbers/${props.modelValue.id}`"
                    >
                        Go to Number
                        <font-awesome-icon widthAuto :icon="faSquareArrowUpRight"></font-awesome-icon>
                    </vx-dropdown-item>
                    <vx-dropdown-item
                        v-if="isImpersonatingOrPlatformAdmin"
                        data-test="remove"
                        @click="removePhoneNumberFromPool()"
                    >
                        Remove Number
                        <font-awesome-icon widthAuto :icon="faCircleMinus"></font-awesome-icon>
                    </vx-dropdown-item>
                </template>
            </vx-dropdown>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script setup>
import {
    VxButton,
    VxDropdown,
    VxDropdownItem,
    VxSwal,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { formatPhoneNumber } from '~/components/filters';
import { countryEmoji } from '~/utils/string';
import { faCircleMinus, faEllipsis, faSquareArrowUpRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { adminPhoneNumberPoolsClient } from '~/services';
import { throwSwalRequestError } from '~/utils/request';
import { usePhoneNumberPoolDetails } from '~/components/settings/teams/phone-number-pools/usePhoneNumberPoolDetails';
import { formatNumberType } from '~/constants/phoneNumbers';

const isImpersonatingOrPlatformAdmin = Spark.isImpersonating || Spark.isPlatformAdmin;

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['removed']);
const { phoneNumberPool } = usePhoneNumberPoolDetails();

const removePhoneNumberFromPool = () => {
    VxSwal.confirmation(
        'Remove Phone Number',
        'Are you sure you want to remove the phone number from the phone pool? This will also remove the phone number from the underlying messaging service.',
        'danger',
        () =>
            adminPhoneNumberPoolsClient
                .addRemovePoolNumbers(props.modelValue.team_id, 'remove', phoneNumberPool.value.id, [
                    props.modelValue.id,
                ])
                .then(() => emit('removed', props.modelValue.id))
                .catch(throwSwalRequestError)
    );
};
</script>
